// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/projectRoute.test.tsx
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ProjectPage } from "../pages/AskV2ProjectPage";

export const askV2ProjectRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/projects/$projectId",
  component: AskV2ProjectRoutePage,
});

function AskV2ProjectRoutePage() {
  const { projectId } = askV2ProjectRoute.useParams();
  // why: same remount key as chatRoute — without it useAskV2Transport keeps the previous project's snapshot across param changes
  return <AskV2ProjectPage key={projectId} projectId={projectId} />;
}
